// extracted by mini-css-extract-plugin
module.exports = {"container":"search_container__lEQgz","sm":"search_sm__aBqoa","md":"search_md__8kntj","lg":"search_lg__6coD0"};